import { useQuery } from "react-query";
import adminApi from "../api/adminApi";

export const useDashboardStats = () => {
  return useQuery("admin-dashboard-stats", () => adminApi.getDashboardStats(), {
    staleTime: 30000,
  });
};
